(function () {
  const url = new URL(window.location.href);
  const urlParams = url.searchParams;
  const variantFromUrl = urlParams.get('vargrp');
  const version = '_20250428'; // change this for every new test
  const var1 = `v1grp${version}`;
  const var2 = `v2grp${version}`;
  const isValidVariant = (v) => v === var1 || v === var2;

  const updateSessionStorage = (variant) => {
      const existing = sessionStorage.getItem('riversol_landing_url');
      if (existing && existing.indexOf(variant) === -1) {
          const appended = `${existing}==-[${variant}]-==`;
          sessionStorage.setItem('riversol_landing_url', appended);
      }
  };

  const removeAnyVariantFromSessionStorage = () => {
      const existing = sessionStorage.getItem('riversol_landing_url');
      if (existing) {
          const updated = existing.replace(/==-\[.*?\]-==/g, '');
          sessionStorage.setItem('riversol_landing_url', updated);
      }
  };

  if (isValidVariant(variantFromUrl)) {
      localStorage.setItem('_vargrp', variantFromUrl);
      updateSessionStorage(variantFromUrl);
      return;
  }

  let variant = localStorage.getItem('_vargrp');
  if (variant && !isValidVariant(variant)) {
      localStorage.removeItem('_vargrp');
      removeAnyVariantFromSessionStorage();
      return;
  }

  if (!variant) {
      variant = Math.random() < 0.5 ? var1 : var2;
      localStorage.setItem('_vargrp', variant);
      updateSessionStorage(variant);
  }

  urlParams.set('vargrp', variant);
  url.search = urlParams.toString();
  window.location.replace(url.toString());
})();


// ===================
// GORGIAS CONVERT (UPDATED)
// =====================

function waitForCartJS(callback, retries = 20, interval = 250) {
  const tryLoad = () => {
    if (typeof CartJS !== 'undefined' && typeof CartJS.setAttributes === 'function') {
      callback();
    } else if (retries > 0) {
      setTimeout(() => waitForCartJS(callback, retries - 1, interval), interval);
    } else {
      console.warn('CartJS not available after waiting.');
    }
  };
  tryLoad();
}

(function () {
  // Store UTM campaign link on arrival
  if (location.search.includes('utm_medium=ChatCampaign')) {
    localStorage.setItem('gorgias.campaign.link', location.href);
  }

  function buildAttributes(changedKey, changedValue) {
    // Get values from localStorage or sessionStorage or from passed key/value if relevant
    const hasChat = changedKey === 'gorgias.chat-access-token'
      ? changedValue
      : localStorage.getItem('gorgias.chat-access-token');

    const hasClose = changedKey === 'gorgias.seen-campaigns-ids'
      ? changedValue
      : localStorage.getItem('gorgias.seen-campaigns-ids');

    const hasLink = changedKey === 'gorgias.campaign.link'
      ? changedValue
      : localStorage.getItem('gorgias.campaign.link');

    const hasOpen = changedKey === 'gorgias.activeCampaigns'
      ? changedValue
      : sessionStorage.getItem('gorgias.activeCampaigns');

    const hasAddToCart = changedKey === 'gorgias.activeCampaigns' 
      && JSON.parse(changedValue).length > 1
      && changedValue

    const attributes = [];

    // Engagement logic
    if (hasChat && hasClose) {
      attributes.push({ key: 'gorgias.campaign.engagement', value: 'Chat' });
    } else if (hasAddToCart) {
      attributes.push({ key: 'gorgias.campaign.engagement', value: 'Added to Cart' });
    } else if (hasLink) {
      attributes.push({ key: 'gorgias.campaign.engagement', value: hasLink });
    }

    // Action
    if (hasClose) {
      attributes.push({ key: 'gorgias.campaign.action', value: 'Closed' });
    }

    // Impression logic
    if (hasOpen) {
      attributes.push({ key: 'gorgias.campaign.impression', value: 'Popup' });
    }

    return attributes;
  }

  function updateCartAttributes(key = null, value = null) {
    const attributes = buildAttributes(key, value);
    if (attributes.length === 0) return;

    waitForCartJS(() => {
      attributes.forEach(attr => {
        CartJS.setAttribute(attr.key, attr.value);
      });
    });
  }

  // Initial page load check
  updateCartAttributes();

  // Hook into localStorage.setItem
  const originalLocalSetItem = localStorage.setItem;
  localStorage.setItem = function (key, value) {
    const watchedKeys = [
      'gorgias.chat-access-token',
      'gorgias.seen-campaigns-ids',
      'gorgias.campaign.link'
    ];

    if (watchedKeys.includes(key)) {
      updateCartAttributes(key, value);
    }

    return originalLocalSetItem.apply(this, arguments);
  };

  // Hook into sessionStorage.setItem for gorgias.activeCampaigns
  const originalSessionSetItem = sessionStorage.setItem;
  sessionStorage.setItem = function (key, value) {
    if (key === 'gorgias.activeCampaigns') {
      updateCartAttributes(key, value);
    }

    return originalSessionSetItem.apply(this, arguments);
  };
})();